/* eslint-disable no-param-reassign */
import { ClientStatusEnum, ClientStatusTypes, IClientStatusDTO } from "@hooks/dtos/IClientDTO";

export const clientStatusTypes: IClientStatusDTO[] = [
  {
    status: ClientStatusEnum.ACTIVE,
    text: "Conta ativa",
    title: "Ativo",
    color: "success",
  },
  {
    status: ClientStatusEnum.INACTIVE,
    text: "Conta inativa",
    title: "Inativo",
    color: "danger",
  },
  {
    status: ClientStatusEnum.PENDING,
    text: "Conta pendente de aprovação",
    title: "Pendente",
    color: "danger",
  },
  {
    status: ClientStatusEnum.DELETED,
    text: "Conta excluída",
    title: "Excluído",
    color: "danger",
  },
];

export const getClientStatus = (status: ClientStatusTypes): IClientStatusDTO => {
  let ret = clientStatusTypes.find(
    (eventStatusType) => eventStatusType.status === status,
  );
  if (!ret)
    ret = {
      status: "undefined",
      text: "Error",
      title: "Error",
      color: "danger",
    };
  return ret;
}
